import { AuthenticationEffects } from "./authentication.effects";
import { InstructionDetailsEffects } from "./instruction-details.effects";

import { InstructionEffects } from "./instruction.effects";
import { NotificationEffects } from "./notification.effects";
import { SettingsEffects } from "./settings.effects";

export const EFFECTS = [
  AuthenticationEffects,
  InstructionEffects,
  InstructionDetailsEffects,
  NotificationEffects,
  SettingsEffects,
];
